// ============================================================
// DeductionsBreakdown.tsx — (Big-audit batch 4, item 9) "How these deductions
// were worked out": a small expandable on the statement card for the approver.
// The server's lines: base costs, VAT, recovered costs, anything already paid on
// interim bills and the position that leaves, each deduction, any credit and the
// total, with a plain note of why (lib/settlementInputs deductionsBreakdown).
// Nothing is worked out here.
// ============================================================
import React from 'react'
import { money } from '../../billing/billingUi'
import type { DeductionsBreakdown as Breakdown } from '../../../types/settlementStatement.types'

const CELL = 'py-[5px] pl-3 text-right tabular-nums whitespace-nowrap'

const DeductionsBreakdown: React.FC<{ breakdown: Breakdown }> = ({ breakdown }) => {
  return (
    <details data-breakdown className="rounded-[12px] border border-casevo-border px-[14px] py-[10px] text-[13px] text-casevo-forest">
      <summary className="cursor-pointer font-semibold rounded-[4px] focus:outline-none casevo-focus">How these deductions were worked out</summary>
      <table className="w-full mt-[10px] border-collapse">
        <tbody>
          {breakdown.lines.map((l) => {
            const total = l.key === 'TOTAL'
            return (
              <tr key={l.key} className={total ? 'font-semibold border-t border-casevo-border' : 'border-t border-casevo-border-soft'}>
                <th scope="row" className="py-[5px] text-left font-[inherit]">{l.label}</th>
                <td className={CELL}>{l.nowPence < 0 ? `−${money(-l.nowPence)}` : money(l.nowPence)}</td>
              </tr>
            )
          })}
        </tbody>
      </table>
      {breakdown.notes.length > 0 && (
        <ul className="m-0 mt-[10px] pl-[18px] list-disc space-y-[4px] text-[12.5px] leading-[1.5] text-casevo-text-soft">
          {breakdown.notes.map((n) => <li key={n}>{n}</li>)}
        </ul>
      )}
    </details>
  )
}

export default DeductionsBreakdown
